/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import RegCarDetailCard from "../reg-car-detail-card";
import { LEAD_FORM, STEP_NAMES } from "../../../constants/app-constants";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.mobile";
import CloseButton from "../../shared/icon-cross";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const RegCarDetailsPopup = ({
    title = "Confirm Car Details",
    userCarRegistrationNo,
    ownerName,
    close,
    confirm,
    brand,
    model,
    year,
    variant,
    fuelType,
    rto, registrationState,
    setStepConnect,
    activateLastStepConnect,
    setIsChangingPreFetchedDetailConnect,
    showProceedButtonConnect,
    allStepFilledConnect,
    showCarOwner = true,
    showMoreDetails = null,
    carRegistrationInfo,
    isLoading = false,
    isRepeatInspection
}) => {

    const { rc_owner_name_masked: maskedOwnerName } = carRegistrationInfo || {};

    const type = LEAD_FORM.DEFAULT;
    const formConfig = FUNNEL_CONFIG[type];

    const nextStep = (stepName) => {
        activateLastStepConnect(false);
        setStepConnect({ currentStep: stepName, tabs: formConfig.tabs });
        allStepFilledConnect(false);
    };

    const onClickHandler = async () => {
        await yieldToMain();
        // setAllDetailFetchedCorrectlyConnect(false);
        confirm();
    };

    const navigateToStep = (data) => {
        const {heading} = data;
        if (heading === "Brand") {
            nextStep(STEP_NAMES.Brand);
        } else if (heading === "Model") {
            nextStep(STEP_NAMES.Model);
        } else if (heading === "Manufacturing Year") {
            nextStep(STEP_NAMES.Year);
        } else if (heading === "Variant") {
            nextStep(STEP_NAMES.Variant);
        } else if (heading === "RTO Code") {
            nextStep(STEP_NAMES.State);
        }

    };

    const editStep = (data) => {
        if (!isRepeatInspection) {
            setIsChangingPreFetchedDetailConnect(true);
            showProceedButtonConnect();
            navigateToStep(data);
        }
    };
    const getTitle = (regTitle) => {
        const regex = /(\w{2})(\d{1,2})(\w{1,3})(\d{4})/;
        return (regTitle || "").replace(regex, "$1-$2-$3-$4");
    };

    const onClose = () => {
        close();
    };

    return (
        <div styleName={"styles.modalWrap"}>
            <div styleName={"styles.header"}>
                <span styleName={"styles.close"} onClick={onClose}>
                    <CloseButton type={"black"} black={true} rotateBy={90} />
                </span>
                <h4 styleName={"styles.heading"}>
                    {title}
                    {userCarRegistrationNo && <strong>Reg. No. {getTitle(userCarRegistrationNo)}</strong>}
                </h4>
            </div>
            <div styleName={"styles.outer"}>
                {
                    showCarOwner &&
                       <RegCarDetailCard
                           heading="Customer Name"
                           label={ownerName || maskedOwnerName}
                           edit={false}
                       />
                }
                <RegCarDetailCard
                    heading="Brand"
                    label={brand.displayText}
                    id={brand.id}
                    clickHandler={editStep}
                />
                <RegCarDetailCard
                    heading="Manufacturing Year"
                    label={year.displayText}
                    id={year.id}
                    clickHandler={editStep}
                />
                <RegCarDetailCard
                    heading="Model"
                    label={model.displayText}
                    id={model.id}
                    clickHandler={editStep}
                />
                <RegCarDetailCard
                    heading="Variant"
                    label={variant.displayText}
                    engineType={fuelType.displayText}
                    id={variant.id}
                    clickHandler={editStep}
                />
                <RegCarDetailCard
                    heading="RTO Code"
                    label={rto.displayText}
                    id={rto.id}
                    clickHandler={() => editStep({
                        heading: "RTO Code",
                        displayText: registrationState.displayText,
                        id: registrationState.id
                    })}
                />
                {
                    showMoreDetails && showMoreDetails.flag &&
                        <React.Fragment>
                            {
                                showMoreDetails.inputs.map((field, index) => (
                                    <RegCarDetailCard
                                        key={index}
                                        heading={field.heading}
                                        label={field.value}
                                        id={field.id}
                                        clickHandler={field.onClickHandler}
                                    />
                                ))
                            }
                        </React.Fragment>
                }
            </div>
            <div styleName={"styles.buttonWrap"} className="shrinkOnTouch">
                <Button text={"CONFIRM"} onClick={onClickHandler} isLoading={isLoading} />
            </div>
        </div>
    );
};

RegCarDetailsPopup.propTypes = {
    title: PropTypes.string,
    userCarRegistrationNo: PropTypes.string,
    ownerName: PropTypes.string,
    close: PropTypes.func,
    confirm: PropTypes.func,
    brand: PropTypes.object,
    model: PropTypes.object,
    year: PropTypes.object,
    variant: PropTypes.object,
    fuelType: PropTypes.object,
    transmission: PropTypes.object,
    registrationState: PropTypes.object,
    rto: PropTypes.object,
    nextStepData: PropTypes.func,
    history: PropTypes.any,
    setDataConnect: PropTypes.func,
    setStepConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func,
    setIsChangingPreFetchedDetailConnect: PropTypes.func,
    showProceedButtonConnect: PropTypes.func,
    applicableCityForSellOnline: PropTypes.array,
    selectedCity: PropTypes.object,
    setAllDetailFetchedCorrectlyConnect: PropTypes.func,
    allStepFilledConnect: PropTypes.func,
    isMmvy: PropTypes.bool,
    showCarOwner: PropTypes.bool,
    showMoreDetails: PropTypes.any,
    isSellOnline: PropTypes.bool,
    carRegistrationInfo: PropTypes.object,
    isLoading: PropTypes.bool,
    isRepeatInspection: PropTypes.bool
};

export default RegCarDetailsPopup;
